import { render, staticRenderFns } from "./OfertaEspecificacao.vue?vue&type=template&id=0a988449&"
import script from "./OfertaEspecificacao.vue?vue&type=script&lang=js&"
export * from "./OfertaEspecificacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
